import React from "react";
import T from "prop-types";
import { usePageTitle } from "2g-hooks";
import { PageMessageError, PageMessageEmpty } from "2g-page-message";
import Loadbar from "2g-loadbar";

import { useZadost } from "b2b/api/hooks";
import ZadostEditaceWidget from "b2b/components/zadost-editace-widget/ZadostEditaceWidget";

import useMessages from "./i18n/useMessages";

export function ZadostDetail({ id }) {
  const { title, notFound } = useMessages();
  const { data, reload, loading, loaded, error } = useZadost({ id });

  usePageTitle(title({ id }));

  return (
    <>
      {loading && <Loadbar />}
      {error ? (
        <PageMessageError error={error} />
      ) : !data && loaded ? (
        <PageMessageEmpty message={notFound({ id })} />
      ) : (
        <ZadostEditaceWidget zadost={data} loading={loading} reload={reload} />
      )}
    </>
  );
}

ZadostDetail.propTypes = { id: T.number.isRequired };

export default React.memo(ZadostDetail);
